import '../../styles/FormInput.css';
import * as React from 'react';

interface IInputControlProps {
    id?: string,
    value: string,
    placeHolder?: string,
    readOnly?: boolean,
    required?: boolean
    erasable?: boolean,
    password?: boolean,
    focused?: boolean,
    isValid?: boolean,
    onBlur?(): void,
    onChange?(value: string): void,
    onFocus?(): void,
    onErase?(): void,
    onKeyDown?(event: React.KeyboardEvent<HTMLInputElement>): void;
}

export const InputControl = (props: IInputControlProps) => {
    const [showPassword, setShowPassword] = React.useState(false);

    // Setup classes for each component
    let labelClass = props.required ? "input-label required" : "input-label";

    let inputClassName = props.isValid === undefined || props.isValid ? "input-box" : "input-box-invalid";

    if (props.focused && ((props.readOnly !== undefined && !props.readOnly) || (props.readOnly === undefined))) {
        inputClassName = inputClassName + " focused";
    }

    if (props.required) {
        labelClass = labelClass + " required";
    }

    return (
        <div style={{ position: "relative" }}>
            <input
                id={props.id}
                className={inputClassName}
                type={props.password && !showPassword ? "password" : "text"}
                onChange={(val) => props.onChange(val.target.value)}
                value={props.value}
                placeholder={props.placeHolder}
                readOnly={props.readOnly}
                onBlur={props.onBlur}
                onFocus={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onFocus && props.onFocus()
                }}
                onKeyDown={(event) => { props.onKeyDown && props.onKeyDown(event) }}
                autoComplete="off"
                onClick={(e) => e.stopPropagation()}
            />
            {
                props.value !== "" && props.erasable && !props.password ?
                    <span
                        className="glyphicon glyphicon-remove delete-text-input "
                        aria-hidden="true"
                        onClick={() => props.onErase()}
                    />
                    :
                    props.password &&
                    <span
                        className="glyphicon glyphicon-eye-open password-eye-input"
                        aria-hidden="true"
                        onMouseOver={() => setShowPassword(true)}
                        onMouseLeave={() => setShowPassword(false)}
                        onTouchStart={() => setShowPassword(true)}
                        onTouchEnd={() => setShowPassword(false)}
                        onTouchCancel={() => setShowPassword(false)}
                    />
            }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/FormControls/InputControl.tsx